<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 财务管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>开票管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-select v-model="query.customerId" placeholder="请选择客户" filterable>
					<el-option key="" label="请选择客户" value=""></el-option>
					<el-option v-for="item in customersKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.status" placeholder="请选择状态">
					<el-option key="" label="请选择状态" value=""></el-option>
					<el-option v-for="item in statusKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column prop="invoiceNo" label="单号" width="250"></el-table-column>
                <el-table-column prop="customerName" label="客户名称" ></el-table-column>
				<el-table-column prop="amount" label="金额" width="150"></el-table-column>
				<el-table-column prop="status" label="状态" width="150" :formatter="statusFormat"></el-table-column>
				<el-table-column prop="createTime" label="申请时间" width="160"></el-table-column>
                <el-table-column label="操作" width="240" align="center">
                    <template slot-scope="scope">
						<el-button
                            type="text"
                            icon="el-icon-view"
                            @click="handleShow(scope.$index, scope.row)"
							v-if = "controll['show'] && scope.row.status > 0"
                        >详情</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-mobile-phone"
							@click="handleBuild(scope.$index, scope.row)"
							v-if = "controll['build'] && scope.row.status == 0"
							v-prevent-re-click
                        >生成</el-button>
						<el-button
                            type="text"
                            icon="el-icon-news"
							@click="handleBilling(scope.$index, scope.row)"
							v-if = "controll['billing'] && scope.row.status == 1"
                        >开票</el-button>
						<el-button
                            type="text"
                            icon="el-icon-close"
							style="color:#E6A23C"
							@click="handleRevoke(scope.$index, scope.row)"
							v-if = "controll['cancel'] && scope.row.status == 1"
                        >撤销</el-button>
						<el-button
                            type="text"
                            icon="el-icon-delete"
							class="red"
							@click="handleCancel(scope.$index, scope.row)"
							v-if = "controll['cancel'] && scope.row.status == 2 || scope.row.status == 3"
                        >作废</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="详情" :visible.sync="showVisible" width="75%">
            <el-form ref="show" :model="show" label-width="120px">
				<el-descriptions class="margin-top" title="" :column="3" size="medium" labelStyle="width:150px;" border>
					<el-descriptions-item>
						<template slot="label">
							客户名称
						</template>
						{{show.customerName}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							发票代码
						</template>
						{{show.invoiceCode}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							发票编号
						</template>
						{{show.invoiceNo}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							金额
						</template>
						{{show.amount}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							开票时间
						</template>
						{{show.billTime}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							开票人
						</template>
						{{show.drawer}}
					</el-descriptions-item><el-descriptions-item>
						<template slot="label">
							状态
						</template>
						{{statusFormat(null, null, show.status)}}
					</el-descriptions-item>
					<el-descriptions-item>
						<template slot="label">
							备注
						</template>
						{{show.remark}}
					</el-descriptions-item>
				</el-descriptions>
				<el-row style="margin-top:20px;">
					<el-tabs v-model="activeName" type="card">
						<el-tab-pane label="开票内容" name="itemTab" style="margin-top:10px">
							<el-table
								:data="salesDetailItems"
								border
								class="table"
								ref="multipleTable"
								header-cell-class-name="table-header"
								:cell-style="{padding:5+'px'}"
								stripe
							>
								<el-table-column prop="code" label="税收编码" width="180"></el-table-column>
								<el-table-column prop="name" label="开票名称" width="280"></el-table-column>
								<el-table-column prop="model" label="型号"></el-table-column>
								<el-table-column prop="num" label="数量" width="80"></el-table-column>
								<el-table-column prop="price" label="价格"></el-table-column>
								<el-table-column prop="amount" label="金额" width="100"></el-table-column>
								<el-table-column prop="taxRate" label="税率" width="80">
									<template slot-scope="scope">
										{{ scope.row.taxRate?(scope.row.taxRate * 100 + "%"):"13%" }}
									</template>
								</el-table-column>
								<el-table-column prop="channelName" label="渠道名称"></el-table-column>
							</el-table>						
						</el-tab-pane>
					</el-tabs>
				</el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showVisible = false">取 消</el-button>
            </span>
        </el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="开票" :visible.sync="billVisible" width="75%">
            <el-form ref="form" :model="form" label-width="120px" :rules="rules">
				<el-row>
					<el-col :span="8">
						<el-form-item label="客户名称：">
							{{form.customerName}}
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="发票代码：" prop="invoiceCode">
							<el-input v-model="form.invoiceCode"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="发票编号：" prop="invoiceNo">
							<el-input v-model="form.invoiceNo"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item label="金额：">
							{{form.amount}}
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="开票日期：" prop="billTime">
							<el-date-picker
								type="date"
								placeholder="请选择开票日期"
								v-model="form.billTime"
								value-format="yyyy-MM-dd"
							></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="开票人：" prop="drawer">
							<el-input v-model="form.drawer"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-tabs v-model="activeName" type="card">
						<el-tab-pane label="开票内容" name="itemTab" style="margin-top:10px">
							<el-table
								:data="salesDetailItems"
								:key="editEnable"
								border
								class="table"
								ref="multipleTable"
								header-cell-class-name="table-header"
								:cell-style="{padding:4+'px'}"
								stripe
							>
								<el-table-column prop="code" label="税收编码(9位)" width="140">
									<template slot-scope="scope">
										<el-input
										  v-if="scope.row.edit"
										  v-model="scope.row.code"
										  placeholder="税收编码"
										></el-input>
										<span v-else>{{ scope.row.code }}</span>
									</template>
								</el-table-column>
								<el-table-column prop="name" label="开票名称" width="280">
									<template slot-scope="scope">
										<el-input
										  v-if="scope.row.edit"
										  v-model="scope.row.name"
										  placeholder="开票名称"
										></el-input>
										<span v-else>{{ scope.row.name }}</span>
									</template>
								</el-table-column>
								<el-table-column prop="model" label="型号"></el-table-column>
								<el-table-column prop="num" label="数量" width="80"></el-table-column>
								<el-table-column prop="price" label="价格" width="100"></el-table-column>
								<el-table-column prop="amount" label="金额" width="100">
								</el-table-column>
								<el-table-column prop="taxRate" label="税率" width="90">
									<template slot-scope="scope">
										<el-input
										  v-if="scope.row.edit"
										  v-model="scope.row.taxRate"
										  placeholder="税率"
										></el-input>
										<span v-else>{{ scope.row.taxRate * 100 }}%</span>
									</template>
								</el-table-column>
								<el-table-column prop="channelName" label="渠道名称"></el-table-column>
								<el-table-column label="操作" width="130" align="center">
								<template slot-scope="scope">
									<el-button
										type="text"
										icon="el-icon-edit"
										v-if="scope.row.edit==undefined||scope.row.edit==false"
										@click="handleRowEdit(scope.$index, scope.row)"
									>编辑</el-button>
									<el-button
										type="text"
										icon="el-icon-check"
										v-if="scope.row.edit"
										@click="handleRowSave(scope.$index, scope.row)"
									>保存</el-button>
									<el-button
										type="text"
										icon="el-icon-close"
										v-if="scope.row.edit"
										@click="handleRowCancel(scope.$index, scope.row)"
									>取消</el-button>
									<el-button
								</template>
							</el-table-column>
							</el-table>						
						</el-tab-pane>
					</el-tabs>
				</el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="billVisible = false">取 消</el-button>
				<el-button type="primary" @click="updateDetailItems" v-prevent-re-click v-if="rowChange">更新开票内容</el-button>
				<el-button @click="exportDetail" v-prevent-re-click v-if="rowChange==false">导出清单</el-button>
				<el-button type="primary" @click="update" v-prevent-re-click v-if="rowChange==false">更 新</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchSalesBillingData, saveSales, deleteSales, getSales, cancelSales, revokeSales, 
getAllCustomerKV, buildInvoice, getSalesDetailBySalesId, 
saveSalesDetail, exportSalesTaxDetail, updateSalesDetailItems } from '../../../api/index';
export default {
    name: 'sales-billing',
    data() {
        return {
            query: {
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
			showVisible: false,
			billVisible:false,
            pageTotal: 0,
            form: {},
			show:{},
            idx: -1,
            id: -1,
			title:"",
			statusKV:[{"key":0,"value":"申请中"},{"key":1,"value":"开票中"},{"key":2,"value":"已开票"},{"key":3,"value":"已发出"},{"key":4,"value":"已签收"},{"key":5,"value":"已作废"}],
			customersKV:[],
			salesDetailItems:[],
			rules:{
				invoiceCode:[{ required: true, message: '请输入发票编码', trigger: 'blur' }],
				invoiceNo:[{ required: true, message: '请输入发票号', trigger: 'blur' }],
				billTime:[{ required: true, message: '请选择开票日期', trigger: 'blur' }],
				drawer:[{ required: true, message: '请输入开票人', trigger: 'blur' }]
			},
			controll:{},
			activeName:"itemTab",
			rowBackUp:{},
			editEnable:false,
			rowChange:false
        };
    },
    created() {
		this.controll = getControll("sales-billing");
		this.getCustomers();
        this.getData();
    },
    methods: {
		//编辑
		handleRowEdit(index, row) {
			this.rowBackUp = {};
			for(var item in row) {
				this.rowBackUp[item] = row[item];
			}
			row.edit = true;
			this.editEnable=true;
		},
		//保存
		handleRowSave(index, row) {
			row.edit = false;
			this.editEnable=false;
			this.rowChange = true;
		},
		//取消
		handleRowCancel(index, row) {
			let isNotChange = true;
			delete row["edit"];
			for(var item in row) {
				isNotChange = this.rowBackUp[item] == row[item];
				if (!isNotChange) {
					break;
				}
			}
			if (isNotChange) {
				row.edit=false;
				this.editEnable=false;
				return;
			}
			this.$confirm('确定要取消修改吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					for(var item in row) {
						row[item]= this.rowBackUp[item]?this.rowBackUp[item]:"";
					}
					row.edit=false;
					this.editEnable=false;
                })
                .catch(() => {});
		},
		updateDetailItems() {
			this.$confirm('确定要更新已修改开票内容吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					for(var item in this.salesDetailItems) {
						delete item["edit"];
					}
					let submitForm = {};
					submitForm["id"] = this.form.id;
					submitForm["items"] = this.salesDetailItems;
					updateSalesDetailItems(submitForm).then(res => {
						if (res.code == 0) {
							this.rowChange = false;
							this.$message.success(`更新成功！`);
						} else {
							this.$message.error(`更新失败！` + res.message);
						}
					});
					
                })
                .catch(() => {});
		},
		//状态格式化
		statusFormat(row, column, cellValue) {
			for (var i = 0; i < this.statusKV.length; i++) {
				if (this.statusKV[i].key === cellValue){
					return this.statusKV[i].value;
				}
			}
			return cellValue;
		},
		//获取客户
		getCustomers() {
			getAllCustomerKV().then(res => {
				if (res.code == 0) {
					this.customersKV = res.data;
				} else {
					this.$message.error(`获取渠道信息失败！` + res.message);
				}
			});
		},
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchSalesBillingData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
					let amount = 0;
					let summary = {};
					summary["customerName"] = "合计：";
					for (var i = 0; i < res.data.records.length; i++) {
						amount += res.data.records[i]["amount"];
					}
					summary["amount"] = amount;
					if (res.data.tatistics) {
						let tatistics = {};
						summary["status"] = "总计：";
						summary["createTime"] = res.data.tatistics["amount"];
					}
					this.tableData.push(summary);
				} else {
					this.$message.error(res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
		//开票
		handleBilling(index, row){
			this.form = {};
			this.salesDetailItems = [];
			getSalesDetailBySalesId(row.id).then(res => {
				if (res.code == 0 ) {
					this.form = res.data[0];
					this.form['customerName'] = row['customerName'];
					this.salesDetailItems = JSON.parse(this.form.items);
					this.billVisible = true;
					this.editEnable = false;
					this.rowChange = false;
				} else {
					this.$message.error(res.message);
				}
			});
		},
		handleCancel(index, row){
			getSalesDetailBySalesId(row.id).then(res => {
				if (res.code == 0 ) {
					this.$confirm("确定要作废 " + row.customerName + "编号：" + res.data[0].invoiceCode + "-" + res.data[0].invoiceNo +" 的发票吗？", '提示', {
						type: 'warning'
					})
						.then(() => {
							cancelSales(row.id).then(res => {
								if (res.code == 0 ) {
									this.$set(row, 'status', 5);
								} else {
									this.$message.error(res.message);
								}
							});
						})
						.catch(() => {});
				} else {
					this.$message.error(res.message);
				}
			});
		},
		handleRevoke(index, row) {
			this.$confirm("确定要撤销 " + row.customerName +" 的发票信息吗？", '提示', {
				type: 'warning'
			})
				.then(() => {
					revokeSales(row.id).then(res => {
						if (res.code == 0 ) {
							this.$set(row, 'status', 0);
						} else {
							this.$message.error(res.message);
						}
					});
				})
				.catch(() => {});
		},
		// 生成
		handleBuild(index, row) {
			buildInvoice(row.id).then(res => { 
				if (res.code == 0 ) {
					this.$message.success("生成发票记录成功");
					this.getData();
				} else {
					this.$message.error(res.message);
				}
            });
		},
		//详情操作
		handleShow(index, row) {
			this.show = {};
			this.salesDetailItems = [];
			getSalesDetailBySalesId(row.id).then(res => {
				if (res.code == 0 ) {
					this.show = res.data[0];
					this.show['status'] = row['status'];
					this.show['remark'] = row['remark'];
					this.show['customerName'] = row['customerName'];
					this.salesDetailItems = JSON.parse(this.show.items);
					this.showVisible = true;
				} else {
					this.$message.error(res.message);
				}
			});
		},
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		// 保存编辑
        update() {
			this.$refs.form.validate(valid => {
				if (valid) {
					let data = {};
					data.id = this.form.id;
					data.salesId = this.form.salesId;
					data.invoiceCode = this.form.invoiceCode;
					data.invoiceNo = this.form.invoiceNo;
					data.billTime = this.form.billTime;
					data.drawer = this.form.drawer;
					saveSalesDetail(data).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.billVisible = false;
							this.getData();
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
		exportDetail() {
			exportSalesTaxDetail(this.form.salesId).then(res => {
				if (res.code == 0) {
					var linkTag = document.createElement("a");
					linkTag.href = "/blob/export/sales-tax-detail?key=" + res.data;			
					linkTag.click();
					linkTag.remove();
				} else {
					this.$message.error(`清单生成失败！` + res.message);
				}
			});
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
